import React from 'react';
import { DIALOG_TYPE } from '../../../../constants';
import { Button } from '../../../../ui';
import { SecondaryTypography } from '../../../../ui/typography/typography';
import styles from './Modals.module.css';

type DeleteUnitModalProps = {
  deleteUnit: () => void;
  cancelEvent: () => void;
};

export const DeleteUnitModal = ({
  deleteUnit,
  cancelEvent,
}: DeleteUnitModalProps) => {
  return (
    <>
      <SecondaryTypography.Small keepDefaultMargins={true}>
        Warning - By pressing the <b>Delete</b> button below, the selected unit
        and all branches underneath it will be permanently deleted.
      </SecondaryTypography.Small>
      <SecondaryTypography.Small keepDefaultMargins={true}>
        To cancel this operation, press the <b>Cancel</b> button below
      </SecondaryTypography.Small>
      <div className={styles.deleteModalButtons}>
        <Button
            dialogType={DIALOG_TYPE.ERROR}
            onClick={deleteUnit}
            variant='primary'
            label='Delete'
        />
        <Button onClick={cancelEvent} variant='secondary' label='Cancel' />
      </div>
    </>
  );
};
